import { Component, OnInit, Injectable } from '@angular/core';
import {MatProgressSpinnerModule, MatGridListModule} from '@angular/material';
import { TranslationService } from 'angular-l10n';
import { HumanResourcesService } from './human-resources.service';
import {MatTabsModule} from '@angular/material/tabs';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';

@Component({
  selector: 'app-human-resources',
  templateUrl: './human-resources.component.html',
  styleUrls: ['./human-resources.component.scss'],
})


export class HumanResourcesComponent implements OnInit {
  /*Totals*/
  public mostrarTotales = false;
  public mostrarTotalesRojos = false;
  public total: any;
  public presupuesto: any;
  public tag:any = "No tag added yet";
  /*Totals*/

  /*Timeline*/
  alternate: boolean = true;
  toggle: boolean = true;
  color: boolean = false;
  size: number = 40;
  expandEnabled: boolean = true;
  fecha = new Date();
  entries = [];
  public localresources:any = [];
  /*Timeline*/
  /*Tree data*/
  public LocalChildren:any=[];
  public nombre:any;
  public arbol:any;
  public tipo:any;
  public text:any;
  public tenants:any =[];
  public corps:any=[];
  public persons:any = [];
  public resources:any=[];
  public info:any=[];
  public ResNumbers:any=[];
  public SelectedAccount = '';

  public eventData:any=[];
  public newEvent = false;
  public eventNumber:string;
  public eventType:string;
  public eventOwner:string;
  public eventCarrier:number = 0;
  public eventTenant:number;
  /*Tree data*/

  selected = 'none';
  daddy = '';
  /*Person and Corp Data*/
  name ="";
  lastName ="";
  jobTitle="";
  budget=0;
  /*Person and Corp Data*/
  rfc="";
  /*Resource Data*/
  account="";
  /*Resource Data*/

  public editar = false;
  public Isloading = true;
  public agregar = false;
  public historial = false;
  public mostrar = false;
  public selectedItem: number;

  public invocado = false;

  constructor(
    private service: HumanResourcesService,
    private translationService: TranslationService,
    private Progressbar: MatProgressSpinnerModule,
    private grid: MatGridListModule,
    private tab: MatTabsModule,
    private textfield: MatInputModule,
    private formfiled: MatFormFieldModule,
    ) {}

  ngOnInit() {
    
    setTimeout(()=>
    this.Isloading = false,90000);
    this.Isloading = true;
    console.log(this.resources);
    this.createRawTree();

  }

  showHide(type:any)
  {
    if (this.invocado == false)
    {
      this.createRawTree();
    }
    
    this.mostrar = !this.mostrar;
    if(type == "edit")
    {
      this.editar = !this.editar;
    }

    if(type == "add")
    {
      this.agregar = !this.agregar;
    }

    if(type == "history")
    {
      this.historial = !this.historial;
    }

  }

  createRawTree()
  {
    
      //Primer nivel:
      this.service.getData().subscribe((response:any=[])=> {
        
        for(var x in response){
          let key = response[x].encoded_key;
          this.service.whoIs(key).subscribe((response:any)=>{
            this.arbol = response;
            this.nombre = this.arbol.object.Name;
            this.tipo = this.arbol.Type;
            
            //IF
            if (this.tipo == 'tenant')
            {
              this.tenants.push({
                value:key,
                viewValue:this.arbol.object.Name
              });
            }
            
            else if (this.tipo == 'corpStructure')
            {
              this.corps.push({
                value:key,
                viewValue:this.arbol.object.Name
              });
            } 
            else if (this.tipo == 'person')
            {
              this.persons.push ({
                value:key,
                viewValue:this.arbol.object.Name +" "+ this.arbol.object.LastName
              });
            } 
            else if (this.tipo == 'resource')
            {
              this.resources.push ({
                value:key,
                viewValue:this.arbol.object.Account
              });
            } 
            //IF
              
          });

        };
      });

  }


  add(val:any)
  {
    this.selected= val;
    if (this.selected == "person")
    {
      this.info = {
        type : "person",
        name: this.name,
        lastName: this.lastName,
        jobTitle: this.jobTitle,
        budget: this.budget,
        parentKey: this.daddy
      };
    }
    else if (this.selected == "tenant")
    {
      this.info = {
        type : "tenant",
        name: this.name,
        budget: this.budget,
        rfc: this.rfc,
        parentKey: this.daddy
      };
    }
    else if (this.selected == "corpStructure")
    {
       this.info = {
        type : "corpStructure",
        name: this.name,
        budget: this.budget,
        parentKey: this.daddy
      };
    }
    else if (this.selected == "resource")
    {
       this.info = {
        type : "resource",
        name: this.name,
        account: this.account,
        parentKey: this.daddy
      };

    }
    console.log(this.info);
    
    this.service.addResource(this.info).subscribe((response: any) => {
      console.log(response);
      this.name = "";
      this.account = "";
      this.budget = 0;
      this.selected = "";
      this.daddy = "";
      this.jobTitle = "";
      this.lastName="";
      this.ngOnInit();
    });
    
  }


  changeInfo(dad:any, opc:any){
    if(dad != "" && opc != ""){

      this.service.whoIs(dad).subscribe((response: any) => {

         if(opc == "corpStructure"){

          response.object.Name = this.name;
          response.object.Budget= this.budget;

          this.name = "";
          this.budget = 0;

        }else if(opc == "person"){

          response.object.Name = this.name;
          response.object.LastName = this.lastName;
          response.object.Budget = this.budget ;

          this.name = ""
          this.lastName= ""
          this.budget =0;
        }
        this.service.changeInfo(response).subscribe((resultado: any) => {
          console.log(resultado);
        });
      });
    }


  }

  /*Timeline methods*/

  getResourceData()
  {
  // Obtener datos de la bd
  /*DENTRO DE FOR EACH
  if (response.action == 1)
      {
        this.eventType = "Robo"
      }
      else if(response.action == 2)
      {
        this.eventType = "Cambio de dueño"
      }
      else if(response.action == 3)
      {
        this.eventType = "Extravío"
      }
      else if(response.action == 4)
      {
        this.eventType = "Equipo descompuesto"
      }
      else if(response.action == 5)
      {
        this.eventType = "Otro"
      }
    
    this.service.whoIs(response.entity_owner).subscribe((response: any) => { 
      this.eventOwner = response.name;
    });
    this.entries.push({
      owner:this.eventOwner,
      action:this.eventType,
    });
    DENTRO DE FOR EACH*/
  }

  addEntry() {
    this.newEvent = true;
  }

  removeEntry() {

    if(this.selectedItem == -1)
    {
      console.log("nope"+this.selectedItem);
    }else{
      this.entries.splice(this.selectedItem,1);          
      this.selectedItem=-1;
      //console.log(this.selectedItem);
    }
   
  }

  onHeaderClick(event) {
    if (!this.expandEnabled) {
      event.stopPropagation();
    }
  }

  onDotClick(event) {
    if (!this.expandEnabled) {
      event.stopPropagation();
    }
  }

  onExpandEntry(expanded, index) {
    console.log(`Expand status of entry #${index} changed to ${expanded}`);

    if (expanded == true)
    {
      this.selectedItem = index;
    }

  }

  addEvent(){

    this.eventNumber = this.SelectedAccount;
    this.eventTenant = 1;

    this.eventData.push({
      phone_number:this.eventNumber,
      owner:this.eventOwner,
      action:this.eventType,
      carrier_id:0,
    });
    console.log(this.eventData);
    this.service.addLineEvent(this.eventData).subscribe((response: any) => {
      console.log("addEvent "+response);
      this.newEvent = false;
    });
    
    this.entries.push({
      owner: this.eventOwner,
      action: this.eventType,
      date: this.fecha.toDateString()
    });
    this.eventData = [];

  }

  resetAndClose(opt:any){
    
    if (opt == 'close')
    {
      this.SelectedAccount = '';
      this.mostrar = !this.mostrar;
      if (this.historial == true)
      {
        this.historial = !this.historial;

      }
      if (this.editar == true)
      {
        this.editar = !this.editar;

      }
      if (this.agregar == true)
      {
        this.agregar = !this.agregar;

      }
    }
    else if (opt == 'back')
    {
      this.SelectedAccount = '';
    }
    else if (opt == 'backEvent')
    {
      this.newEvent = false;
    }

  }

  /*Timeline methods*/



}//fin de la clase




// WEBPACK FOOTER //
// ./src/app/views/human-resources/human-resources.component.ts